import { AvailableTimeslots } from '@App/services/api/ProviderTimeslots/types/AvailableTimeslots';
import { makeStyles, Typography } from '@material-ui/core';
import { CORPORATE_COLORS } from '@Ui/theme/colors/corporate';
import classNames from 'classnames';
import React from 'react';

const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: CORPORATE_COLORS.WHITE,
    marginBottom: '20px',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      backgroundColor: CORPORATE_COLORS.LIGHT_GRAY,
      maxWidth: '365px',
      padding: '20px'
    }
  },
  table: {
    width: '100%'
  },
  thead: {
    '& th': { color: CORPORATE_COLORS.DARK_GRAY, fontWeight: 'bold', fontSize: '16px' }
  },
  tbody: {
    '& td': {
      color: CORPORATE_COLORS.DARK_GRAY
    }
  },
  grow: {
    width: '100%'
  },
  shrink: {
    whiteSpace: 'nowrap'
  },
  dateCell: {
    textAlign: 'left'
  },
  countCell: {
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      textAlign: 'right'
    }
  }
}));

interface TimeslotsListProps {
  timeslots: AvailableTimeslots;
}

export const TimeslotsList: React.FC<TimeslotsListProps> = ({ timeslots }) => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      {Object.keys(timeslots).map(date => (
        <table key={date} className={styles.table}>
          <thead className={styles.thead}>
            <tr>
              <th className={classNames(styles.grow, styles.dateCell)}>
                <Typography variant="subtitle1">{date}</Typography>
              </th>
              <th className={classNames(styles.shrink, styles.countCell)}>
                <Typography variant="subtitle1">Freie Termine</Typography>
              </th>
            </tr>
          </thead>
          <tbody className={styles.tbody}>
            {Object.values(timeslots[date]).map(timeslot => (
              <tr key={`${date}_${timeslot.from}-${timeslot.to}`}>
                <td className={classNames(styles.grow, styles.dateCell)}>
                  <Typography variant="body1">{`${timeslot.from} - ${timeslot.to}`}</Typography>
                </td>
                <td className={classNames(styles.shrink, styles.countCell)}>
                  <Typography variant="body1">{timeslot.count}</Typography>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ))}
    </div>
  );
};
